import { Map } from 'immutable';

import * as types from './types';

const initialState = Map({
  loading: true,
});

const authReducer = (state = initialState, { type }) => {
  switch (type) {
    // It will failure on /team-management/v1/users/me/ call for unauthenticated user
    case types.INITIALIZE.SUCCESS:
    case types.INITIALIZE.FAILURE:
      return state.set('loading', false);
    default:
      return state;
  }
};

export default authReducer;
export { initialState };
